import React from 'react';
import NowMovieBlock from "../NowMovieBlock";
import { SessionType } from '../../types/entities';
import { FilterItem } from '../common/Showtimes/ShowtimesBlockCinemaFilters';
import BillboardHeading from '../billboard/BillboardHeading';

interface Props {
  baseUrl: string;
  sessions: Array<SessionType>;
  timeLimit: number | null;
  onCinemasEdit: () => void;
  onTimeEdit: () => void;
}

const NowPageContent: React.FC<Props> = (props) => {

  return (
    <>
      <BillboardHeading title="Por comenzar" onCinemasEdit={props.onCinemasEdit} onTimeEdit={props.onTimeEdit} />

      <div className="list-group mb-4">
        {props.sessions.map(session => <NowMovieBlock session={session} key={session.id} />)}
      </div>
    </>
  );
}

export default NowPageContent;